import { IGroupConditionForm } from '../interfaces/IGroupConditionForm';
import { IPassportGroupForm } from '../interfaces/IPassportGroupForm';
import { FormErrors } from '../../../KnmPackage/MainModule/types/FormErrors';
import { makeRequired } from '../../../CorePackage/MainModule/validators/isRequired';
import { REQUIRED_ERROR } from '../../../CorePackage/MainModule/constants/validationErrors';
import { IGroupCommonConditionsForm } from '../interfaces/IGroupCommonConditionsForm';
import { IGroupAssignmentConditionsForm } from '../interfaces/IGroupAssignmentConditionsForm';
import { IGroupSubjectConditionsForm } from '../interfaces/IGroupSubjectConditionsForm';

const groupCommonConditionValidate = (
  commonCondition: IGroupCommonConditionsForm | undefined,
): FormErrors<IGroupCommonConditionsForm> | string => {
  return {
    startDate: commonCondition?.endDate ? makeRequired(REQUIRED_ERROR)(commonCondition.startDate) : undefined,
    endDate: commonCondition?.startDate ? makeRequired(REQUIRED_ERROR)(commonCondition.endDate) : undefined,
  };
};

const groupAssignmentConditionValidate = (
  assignmentCondition: IGroupAssignmentConditionsForm | undefined,
): FormErrors<IGroupAssignmentConditionsForm> => {
  return {
    assigmentStartDate: assignmentCondition?.assigmentEndDate
      ? makeRequired(REQUIRED_ERROR)(assignmentCondition.assigmentStartDate)
      : undefined,
    assigmentEndDate: assignmentCondition?.assigmentStartDate
      ? makeRequired(REQUIRED_ERROR)(assignmentCondition.assigmentEndDate)
      : undefined,
  };
};

const groupSubjectConditionValidate = (
  subjectCondition: IGroupSubjectConditionsForm | undefined,
): FormErrors<IGroupSubjectConditionsForm> => {
  return {
    checkResultStartDate: subjectCondition?.checkResultEndDate
      ? makeRequired(REQUIRED_ERROR)(subjectCondition.checkResultStartDate)
      : undefined,
    checkResultEndDate: subjectCondition?.checkResultStartDate
      ? makeRequired(REQUIRED_ERROR)(subjectCondition.checkResultEndDate)
      : undefined,
  };
};

const groupConditionValidate = (condition: IGroupConditionForm): FormErrors<IGroupConditionForm> | string => {
  return {
    commonConditions: groupCommonConditionValidate(condition.commonConditions),
    assignmentConditions: groupAssignmentConditionValidate(condition.assignmentConditions),
    subjectConditions: groupSubjectConditionValidate(condition.subjectConditions),
  };
};

export const passportGroupFormValidate = (values: IPassportGroupForm): FormErrors<IPassportGroupForm> => {
  return {
    includes: values.includes?.map(groupConditionValidate),
    exceptions: values.exceptions?.map(groupConditionValidate),
  };
};
